import {
  CANDIDATE_PROFILE_DETAILS_REQUEST, CANDIDATE_PROFILE_DETAILS_FAIL, CANDIDATE_PROFILE_DETAILS_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: true,
  action: "Home Action",
  result: null,
  msg: "",
  error: "",
};

const CandidateProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_PROFILE_DETAILS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case CANDIDATE_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case CANDIDATE_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};

export default CandidateProfileReducer;
